import { Sort } from '@angular/material/sort';
import { ModuleUserExtended } from 'app/library/module-user/models/module-user.extended.model';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyPinnedModules {
    static readonly type = '[MyPinnedModules] SetMyPinnedModules';

    constructor(public payload: ModuleUserExtended[]) {}
}

export class UnsetMyPinnedModules {
    static readonly type = '[MyPinnedModules] UnsetMyPinnedModules';
}

export class AddMyPinnedModules {
    static readonly type = '[MyPinnedModules] AddMyPinnedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyPinnedModule {
    static readonly type = '[MyPinnedModules] FetchMyPinnedModule';

    constructor(public payload: string) {}
}

export class FetchMyPinnedModules {
    static readonly type = '[MyPinnedModules] FetchMyPinnedModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isPinned?: boolean;
            participantId?: string;
            tag?: number[];
            isParticipant?: boolean;
            isManager?: boolean;
        }
    ) {}
}

export class FetchMyPinnedModulesSuccess {
    static readonly type = '[MyPinnedModules] FetchMyPinnedModulesSuccess';
}

export class FetchMyPinnedModulesFailure {
    static readonly type = '[MyPinnedModules] FetchMyPinnedModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyPinnedModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyPinnedModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyPinnedModules] DeselectSelectedModules';
}

export class SearchMyPinnedModules {
    static readonly type = '[MyPinnedModules] SearchMyPinnedModules';

    constructor(public payload: string) {}
}

export class SortMyPinnedModules {
    static readonly type = '[MyPinnedModules] SetMyPinnedModulesSort';

    constructor(public payload: Sort) {}
}
